(function(){
  var d = document;
  var T = window.theme || {};
  function ready(fn){ if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function rootUrl(){ var r = T.root || '/'; return r.slice(-1) === '/' ? r.slice(0, -1) : r; }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function fmt(cents){
    cents = Number(cents) || 0;
    var f = T.moneyFormat || '{{amount}}';
    var a = f.indexOf('{{'), b = f.indexOf('}}');
    if (a < 0 || b < 0) return (cents / 100).toFixed(2);
    var key = f.slice(a + 2, b).trim();
    var comma = key.indexOf('comma_separator') > -1;
    var s = (cents / 100).toFixed(key.indexOf('no_decimals') > -1 ? 0 : 2).split('.');
    var int = s[0], out = '';
    while (int.length > 3) { out = (comma ? '.' : ',') + int.slice(-3) + out; int = int.slice(0, -3); }
    out = int + out + (s[1] ? (comma ? ',' : '.') + s[1] : '');
    return f.slice(0, a) + out + f.slice(b + 2);
  }
  function toast(msg, extra){
    var t = d.getElementById('toast'); if (!t) return;
    t.innerHTML = '<span>✦</span>' + msg + (extra || '');
    t.classList.add('show'); clearTimeout(t._t);
    t._t = setTimeout(function(){ t.classList.remove('show'); }, 2800);
  }
  window.pbToast = toast;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 }) : null;
  function initReveal(root){
    var els = (root || d).querySelectorAll('.rv:not(.in)');
    Array.prototype.forEach.call(els, function(el, i){
      if (!io) { el.classList.add('in'); return; }
      if (!el.style.transitionDelay) el.style.transitionDelay = (el.getAttribute('data-delay') || ((i % 5) * 80)) + 'ms';
      io.observe(el);
    });
  }

  function refreshCount(){
    return fetch(T.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      d.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = c.item_count; el.hidden = c.item_count === 0;
        el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
      });
    });
  }

  var WK = 'pb-wishlist';
  function getW(){ try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } }
  function setW(a){ try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} }
  function paintW(){ var w = getW(); d.querySelectorAll('[data-wish]').forEach(function(b){ b.classList.toggle('on', w.indexOf(b.getAttribute('data-wish')) > -1); }); }

  function renderWishlist(){
    var grid = d.querySelector('[data-wishlist-grid]'); if (!grid) return;
    var empty = d.querySelector('[data-wishlist-empty]');
    var w = getW();
    if (!w.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(w.map(function(h){
      return fetch(rootUrl() + '/products/' + encodeURIComponent(h) + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(items){
      items = items.filter(Boolean);
      if (!items.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      grid.innerHTML = items.map(function(p){
        var v = p.variants.filter(function(x){ return x.available; })[0] || p.variants[0];
        var src = p.featured_image || '';
        if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
        var img = src ? '<img src="' + src + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
        var cmp = p.compare_at_price > p.price ? '<s>' + fmt(p.compare_at_price) + '</s>' : '';
        return '<div class="product-card rv"><div class="pc-media"><button type="button" class="pc-wish" data-wish-remove="' + esc(p.handle) + '" aria-label="Remove">×</button>' +
          '<a class="pc-img" href="' + p.url + '">' + img + '</a></div><div class="pc-info"><a class="pc-title" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<div class="price"><span class="price-now">' + fmt(p.price) + '</span>' + cmp + '</div>' +
          '<button type="button" class="btn btn-block" style="margin-top:14px;height:46px;font-size:12px;box-shadow:none" data-wish-move="' + v.id + '" data-handle="' + esc(p.handle) + '"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Move to Cart' : 'Sold out') + '</button></div></div>';
      }).join('');
      initReveal(grid);
    });
  }

  function initSliders(root){
    root.querySelectorAll('[data-slider]').forEach(function(s){
      if (s._init) return; s._init = 1;
      var sl = s.querySelectorAll('[data-slide]'); if (!sl.length) return;
      var i = 0;
      function show(n){ i = (n + sl.length) % sl.length; sl.forEach(function(x, k){ x.classList.toggle('active', k === i); }); }
      show(0);
      var p = s.querySelector('[data-prev]'), n = s.querySelector('[data-next]');
      if (p) p.addEventListener('click', function(){ show(i - 1); });
      if (n) n.addEventListener('click', function(){ show(i + 1); });
      if (sl.length > 1) setInterval(function(){ show(i + 1); }, 6500);
    });
  }

  function initProduct(p){
    var j = p.querySelector('[data-variants]'); if (!j) return;
    var vs = JSON.parse(j.textContent);
    var form = p.querySelector('form.pdp-form');
    var idIn = form ? form.querySelector('[name="id"]') : null;
    function upd(){
      var opts = [];
      p.querySelectorAll('[data-option]').forEach(function(fs){
        var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null);
        var l = fs.querySelector('[data-selected]'); if (l && c) l.textContent = c.value;
      });
      var v = vs.filter(function(x){ return x.options.every(function(o, k){ return o === opts[k]; }); })[0];
      var btns = p.querySelectorAll('[data-add-btn]');
      btns.forEach(function(b){
        var s = b.querySelector('[data-add-label]') || b;
        b.disabled = !v || !v.available;
        s.textContent = !v ? 'Unavailable' : (v.available ? 'Add to Cart' : 'Sold out');
      });
      if (!v) return;
      if (idIn) idIn.value = v.id;
      p.querySelectorAll('[data-price]').forEach(function(e){ e.textContent = fmt(v.price); });
      p.querySelectorAll('[data-off]').forEach(function(e){ var on = v.compare_at_price > v.price; e.hidden = !on; if (on) e.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }); p.querySelectorAll('[data-compare]').forEach(function(e){
        if (v.compare_at_price > v.price) { e.hidden = false; e.textContent = fmt(v.compare_at_price); } else e.hidden = true;
      });
      if (v.featured_image) { var img = p.querySelector('[data-main] img'); if (img) { img.src = v.featured_image.src; img.removeAttribute('srcset'); } }
      if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    p.querySelectorAll('[data-option] input').forEach(function(i){ i.addEventListener('change', upd); });
    var sticky = p.querySelector('[data-sticky-atc]');
    if (sticky && form) {
      window.addEventListener('scroll', function(){ sticky.classList.toggle('show', window.scrollY > 700); }, { passive: true });
      var sb = sticky.querySelector('[data-add-btn]');
      if (sb) sb.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  function initGallery(g){
    var main = g.querySelector('[data-main]'); if (!main) return;
    g.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        g.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
        var img = main.querySelector('img'); if (img) { img.src = t.getAttribute('data-src'); img.removeAttribute('srcset'); }
      });
    });
    if (window.matchMedia && matchMedia('(hover: hover)').matches) {
      main.addEventListener('mousemove', function(e){
        var img = main.querySelector('img'); if (!img) return;
        var r = main.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.8)';
      });
      main.addEventListener('mouseleave', function(){ var img = main.querySelector('img'); if (img) img.style.transform = ''; });
    }
  }

  ready(function(){
    var hd = d.querySelector('[data-header]');
    var hero = d.querySelector('[data-hero]');
    var hbg = d.querySelector('[data-hero-bg]');
    var mx = 0, my = 0;
    function para(){ if (!hbg) return; var y = Math.min(window.scrollY, 900); hbg.style.transform = 'translate3d(' + (mx * -18) + 'px,' + (my * -14 + y * .22) + 'px,0)'; }
    function onS(){ if (hd) hd.classList.toggle('scrolled', window.scrollY > 30); para(); }
    window.addEventListener('scroll', onS, { passive: true }); onS();
    if (hero && window.matchMedia && matchMedia('(hover: hover)').matches) {
      hero.addEventListener('mousemove', function(e){ var r = hero.getBoundingClientRect(); mx = ((e.clientX - r.left) / r.width - .5) * 2; my = ((e.clientY - r.top) / r.height - .5) * 2; para(); });
      hero.addEventListener('mouseleave', function(){ mx = 0; my = 0; para(); });
    }
    d.querySelectorAll('[data-sparks]').forEach(function(box){
      for (var k = 0; k < 22; k++) {
        var s = 2 + Math.random() * 3, el = d.createElement('i');
        el.style.left = (Math.random() * 100) + '%'; el.style.width = s + 'px'; el.style.height = s + 'px';
        el.style.setProperty('--dx', ((Math.random() - .5) * 120) + 'px');
        el.style.animationDuration = (7 + Math.random() * 8).toFixed(1) + 's';
        el.style.animationDelay = (Math.random() * 10).toFixed(1) + 's';
        box.appendChild(el);
      }
    });

    initReveal(d); initSliders(d); paintW();
    d.querySelectorAll('[data-product]').forEach(initProduct);
    d.querySelectorAll('[data-gallery]').forEach(initGallery);

    d.querySelectorAll('[data-recs]').forEach(function(el){
      var url = el.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function(r){ return r.text(); }).then(function(h){
        var tmp = d.createElement('div'); tmp.innerHTML = h;
        var n = tmp.querySelector('[data-recs]');
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; initReveal(el); paintW(); }
      });
    });

    var ff = d.querySelector('[data-filter-form]');
    if (ff) ff.addEventListener('change', function(){
      var ps = new URLSearchParams();
      new FormData(ff).forEach(function(v, k){ if (v !== '') ps.append(k, v); });
      location.search = ps.toString();
    });
    var so = d.querySelector('[data-sort]');
    if (so) so.addEventListener('change', function(){
      var u = new URL(location.href); u.searchParams.set('sort_by', so.value); u.searchParams.delete('page'); location.href = u.toString();
    });

    d.querySelectorAll('select[data-default]').forEach(function(s){ var v = s.getAttribute('data-default'); if (v) s.value = v; });

    d.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function(i){
      i.addEventListener('change', function(){ clearTimeout(i._t); i._t = setTimeout(function(){ i.form.submit(); }, 450); });
    });

    renderWishlist();
  });

  d.addEventListener('click', function(e){
    var q = e.target.closest('[data-qty]');
    if (q) {
      var inp = q.parentElement.querySelector('input');
      var v = (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-qty'), 10);
      var mn = parseInt(inp.min || '0', 10); if (v < mn) v = mn;
      inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var w = e.target.closest('[data-wish]');
    if (w) {
      e.preventDefault();
      var list = getW(), h = w.getAttribute('data-wish');
      if (list.indexOf(h) > -1) { list = list.filter(function(x){ return x !== h; }); toast('Removed from wishlist'); }
      else { list.push(h); toast('Saved to wishlist', '<a href="' + rootUrl() + '/pages/wishlist">View</a>'); }
      setW(list); paintW(); return;
    }
    var wr = e.target.closest('[data-wish-remove]');
    if (wr) {
      var hh = wr.getAttribute('data-wish-remove');
      setW(getW().filter(function(x){ return x !== hh; }));
      var card = wr.closest('.product-card');
      if (card) { card.style.transition = 'all .4s'; card.style.opacity = 0; card.style.transform = 'scale(.92)'; }
      setTimeout(renderWishlist, 400); return;
    }
    var wm = e.target.closest('[data-wish-move]');
    if (wm) {
      wm.disabled = true;
      fetch(T.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(wm.getAttribute('data-wish-move')), quantity: 1 }) })
        .then(function(r){ if (!r.ok) throw new Error('x'); var hd2 = wm.getAttribute('data-handle'); setW(getW().filter(function(x){ return x !== hd2; })); toast('Moved to cart', '<a href="' + T.cartUrl + '">View cart</a>'); return refreshCount(); })
        .then(renderWishlist)
        .catch(function(){ wm.disabled = false; toast('Could not add to cart'); });
      return;
    }
    var dc = e.target.closest('[data-discount-apply]');
    if (dc) {
      var ci = d.querySelector('[data-discount]');
      if (ci && ci.value.trim()) location.href = rootUrl() + '/discount/' + encodeURIComponent(ci.value.trim()) + '?redirect=' + encodeURIComponent(T.cartUrl);
      return;
    }
    if (e.target.closest('[data-menu-toggle]')) d.body.classList.toggle('menu-open');
  });

  d.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.classList || !f.classList.contains('js-ajax')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var lab = btn ? (btn.querySelector('[data-add-label]') || btn) : null;
    var old = lab ? lab.textContent : '';
    if (btn) btn.disabled = true;
    fetch(T.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function(){ if (lab) lab.textContent = 'Added ✓'; toast('Added to cart', '<a href="' + T.cartUrl + '">View cart</a>'); return refreshCount(); })
      .catch(function(err){ toast(esc(err.message)); })
      .then(function(){ setTimeout(function(){ if (lab) lab.textContent = old; if (btn) btn.disabled = false; }, 1600); });
  });

  d.addEventListener('shopify:section:load', function(e){
    initReveal(e.target); initSliders(e.target); paintW();
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-gallery]').forEach(initGallery);
  });
})();


/* === Max quantity per item: 2 (applies to every product) === */
(function(){
  var MAX = 2, MSG = 'Maximum ' + MAX + ' pieces allowed per item';
  var SEL = 'input[name="quantity"],input[name="updates[]"],input[name^="updates["]';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var _fetch = window.fetch.bind(window);

  function note(){
    var n = document.getElementById('max-qty-note');
    if (!n) {
      n = document.createElement('div'); n.id = 'max-qty-note'; n.setAttribute('role', 'status');
      n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;background:#111;color:#e8c77a;border:1px solid #e8c77a;padding:10px 16px;border-radius:6px;font:600 13px/1.3 sans-serif;transition:opacity .3s;opacity:0;pointer-events:none';
      document.body.appendChild(n);
    }
    n.textContent = MSG; n.style.opacity = '1';
    clearTimeout(n._t); n._t = setTimeout(function(){ n.style.opacity = '0'; }, 2500);
  }
  function clampEl(i){
    if (!i || i.type === 'hidden') return false;
    i.max = MAX;
    var v = parseInt(i.value, 10) || 0;
    if (v > MAX) { i.value = MAX; return true; }
    return false;
  }
  function setMax(root){ (root || document).querySelectorAll(SEL).forEach(clampEl); }
  function onEdit(e){ var t = e.target; if (t && t.matches && t.matches(SEL) && clampEl(t)) note(); }
  document.addEventListener('change', onEdit, true);
  document.addEventListener('input', onEdit, true);
  document.addEventListener('submit', function(e){
    var c = false;
    if (e.target.querySelectorAll) e.target.querySelectorAll(SEL).forEach(function(i){ if (clampEl(i)) c = true; });
    if (c) note();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setMax(); }); else setMax();
  document.addEventListener('shopify:section:load', function(e){ setMax(e.target); });

  function getCart(){ return _fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }); }
  function cap(n){ n = parseInt(n, 10); return isNaN(n) ? n : Math.min(n, MAX); }

  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var body = init && init.body;
    if (body && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      return getCart().then(function(cart){
        var have = {};
        (cart.items || []).forEach(function(it){ have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; });
        function allow(id, q){
          q = parseInt(q, 10) || 1;
          var left = MAX - (have[id] || 0);
          if (left <= 0) throw new Error(MSG);
          if (q > left) note();
          return Math.min(q, left);
        }
        if (body instanceof FormData) {
          body.set('quantity', allow(body.get('id'), body.get('quantity')));
        } else if (typeof body === 'string') {
          var j = null; try { j = JSON.parse(body); } catch (x) {}
          if (j) {
            if (Array.isArray(j.items)) j.items.forEach(function(it){ it.quantity = allow(it.id, it.quantity); });
            else if (j.id) j.quantity = allow(j.id, j.quantity);
            init.body = JSON.stringify(j);
          }
        }
        return _fetch(input, init);
      });
    }
    if (body && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      if (body instanceof FormData) {
        if (body.has('quantity')) body.set('quantity', cap(body.get('quantity')));
      } else if (typeof body === 'string') {
        var j2 = null; try { j2 = JSON.parse(body); } catch (x) {}
        if (j2) {
          if (j2.quantity != null) j2.quantity = cap(j2.quantity);
          if (j2.updates) { for (var k in j2.updates) j2.updates[k] = cap(j2.updates[k]); }
          init.body = JSON.stringify(j2);
        }
      }
    }
    return _fetch(input, init);
  };

  // Cart page: fix any line already above the limit
  if (/\/cart\/?$/.test(location.pathname)) {
    getCart().then(function(c){
      var u = {}, fix = false;
      (c.items || []).forEach(function(it){ if (it.quantity > MAX) { u[it.key] = MAX; fix = true; } });
      if (fix) _fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: u }) }).then(function(){ location.reload(); });
    });
  }
})();
